import { defineNuxtPlugin } from '#app'

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
  // Check if the 'document' object and its 'body' property exist.
  if (document && document.body) {
    // Create a 'div' element to display the loading component.
    const loaderHtmlComponent = document.createElement('div')
    // Insert the HTML code for the loading component, specified in the plugin options.
    loaderHtmlComponent.innerHTML = `<div id="splash-container" class="splash">
  <div class="splash-wrapper">
    <div class="splash-logo-title">
      <img src="/logo.png" alt="Logo" class="splash-logo" />
      <h3 class="splash-title">Shoot Loot</h3>
      <p class="splash-text">Play To Win Exciting Prizes</p>
    </div>
    <div class="splash-loading">
      <div class="splash-row">
        <p class="splash-loading-text">Loading</p>
        <div class="loader"></div>
      </div>
      <div class="splash-loading-wrapper">
        <!-- <img src="/splash-loading.png" alt="Pic" class="splash-loading-img" /> -->
        <div class="splash-loading-progress-bar"></div>
      </div>
    </div>
  </div>
  <img src="/left-tether.png" alt="Pic" class="left-tether float-diagonal" />
  <img src="/right-tether.png" alt="Pic" class="right-tether float-up-right" />
  <img src="/right-coin.png" alt="Pic" class="right-coin float-diagonal2" />
  <img
    src="/right-bottom-coin.png"
    alt="Pic"
    class="right-bottom-coin orbit-float"
  />
  <img src="/left-coin.png" alt="Pic" class="left-coin float-left-right" />
  <img src="/left-coin2.png" alt="Pic" class="left-coin2 float" />
  <img src="/left-coin3.png" alt="Pic" class="left-coin3 float-left-up" />
  <img
    src="/left-bottom-coin.png"
    alt="Pic"
    class="left-bottom-coin float-top-half"
  />
</div>

<style>
  @font-face {
    font-family: quicksand-font;
    font-style: normal;
    font-weight: 700;
    src: url('/Quicksand-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: quicksand-font;
    font-style: normal;
    font-weight: 600;
    src: url('/Quicksand-SemiBold.ttf') format('truetype');
  }

  .splash {
    background: url(/splash-bkg2.png) no-repeat center;
    background-size: cover;
    height: 100dvh;
    width: 100%;
    position: relative;
    z-index: 10000;
  }

  .splash-wrapper {
    display: grid;
    place-items: center;
    height: 100%;
  }

  .splash-logo {
    width: 162px;
  }

  .splash-title {
    font-size: 40px;
    color: #fff;
  }

  .splash-plus {
    position: absolute;
    background: linear-gradient(89.83deg, #d37434 0%, #ffd901d8 50.15%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-size: 100px;
    top: 111px;
    right: -8px;
    z-index: 1;
  }

  .splash-logo-title {
    display: grid;
    place-items: center;
    position: relative;
    top: 80px;
    gap: 16px;
  }

  .splash-title {
    font-weight: 700;
    margin-top: 16px;
    font-family: quicksand-font;
    z-index: 1;
  }

  .splash-text {
    font-weight: 600;
    /* font-family: rimouski; */
    z-index: 1;
    color: #fff;
    font-size: 20px;
  }

  .splash-loading {
    width: 100%;
    display: grid;
    place-items: center;
  }

  .splash-loading-text {
    font-size: 20px;
    color: #fff;
    font-weight: 600;
    font-family: quicksand-font;
  }

  .splash-loading-wrapper {
    height: 10px;
    border-radius: 20px;
    background-color: black;
    width: 70%;
    margin: 25px auto;
    z-index: 1000;
    position: relative;
  }

  .splash-loading-progress-bar {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 20px;
    background: #ffcd00;
    animation: fill 7s ease-in-out forwards;
  }

  @keyframes fill {
    0% {
      width: 0;
    }

    100% {
      width: 98%;
    }
  }

  .splash-loading-img {
    position: absolute;
    left: -10%;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    animation: move 7s ease-in-out forwards;
  }

  @keyframes move {
    0% {
      left: -10%;
    }

    100% {
      left: 80%;
    }
  }

  .splash-row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 2px;
  }

  .loader {
    width: 15px;
    aspect-ratio: 4;
    background: radial-gradient(circle closest-side, #ffffff 90%, #ffffff00) 0 /
      calc(100% / 3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: l1 1s steps(4) infinite;
  }
  @keyframes l1 {
    to {
      clip-path: inset(0 -34% 0 0);
    }
  }

  .splash-dots p:nth-child(3) {
    animation-delay: 20s;
    animation: dot3 1s linear infinite;
  }

  @keyframes dot3 {
    0% {
      width: 0%;
    }

    100% {
      width: 100%;
    }
  }

  .left-tether {
    position: absolute;
    left: -22px;
    top: 120px;
  }

  .right-tether {
    position: absolute;
    right: -42px;
    top: 250px;
  }

  .right-coin {
    position: absolute;
    right: -38px;
    bottom: 150px;
  }

  .right-bottom-coin {
    position: absolute;
    right: 110px;
    bottom: 100px;
  }

  .left-coin {
    position: absolute;
    bottom: 300px;
    left: -30px;
  }
  .left-coin2 {
    position: absolute;
    bottom: 250px;
    left: 80px;
  }

  .left-coin3 {
    position: absolute;
    bottom: 120px;
    left: 24px;
  }

  .left-bottom-coin {
    position: absolute;
    bottom: 50px;
    left: 100px;
  }

  .float-diagonal {
    display: inline-block;
    animation: float-diagonal 6s ease-in-out infinite;
  }

  @keyframes float-diagonal {
    0% {
      transform: translate(0, 0);
    }
    33% {
      transform: translate(-3px, 10px);
    }
    66% {
      transform: translate(3px, 10px);
    }
    86% {
    }
    100% {
      transform: translate(0, 0);
    }
  }

  .float-up-right {
    display: inline-block;
    animation: float-up-right 6s ease-in-out infinite;
  }

  @keyframes float-up-right {
    0% {
      transform: translate(0, 0);
    }
    25% {
      transform: translate(0, 10px);
    }
    50% {
      transform: translate(0, 10px);
    }
    75% {
      transform: translate(15px, 0);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  .float-left-right {
    display: inline-block;
    animation: float-left-right 8s ease-in-out infinite;
  }

  @keyframes float-left-right {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(10px); /* move smoothly to the right */
    }
    100% {
      transform: translateX(0); /* come smoothly back to start */
    }
  }

  .float-diagonal2 {
    display: inline-block;
    animation: float-diagonal2 8s ease-in-out infinite;
  }

  @keyframes float-diagonal2 {
    0% {
      transform: translate(0, 0);
    }
    33% {
      transform: translate(5px, 7px);
    }
    66% {
      transform: translate(-5px, 0px);
    }

    100% {
      transform: translate(0, 0);
    }
  }

  .orbit-float {
    display: inline-block;
    animation: orbit-float 6s linear infinite;
  }

  @keyframes orbit-float {
    0% {
      transform: rotate(0deg) translateX(10px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(10px) rotate(-360deg);
    }
  }

  .float-cross {
    display: inline-block;
    animation: float-cross 8s ease-in-out infinite;
  }

  .float-top-half {
    display: inline-block;
    animation: float-top-half 6s ease-in-out infinite;
    transform-origin: center bottom; /* pivot point for the half-circle */
  }

  @keyframes float-top-half {
    0% {
      transform: rotate(180deg) translateX(10px) rotate(-180deg);
    }
    50% {
      transform: rotate(90deg) translateX(10px) rotate(-90deg);
    }
    100% {
      transform: rotate(180deg) translateX(10px) rotate(-180deg);
    }
  }

  .float-left-up {
    display: inline-block;
    animation: float-left-up 6s ease-in-out infinite;
  }

  @keyframes float-left-up {
    0% {
      transform: translate(0, 0);
    }
    25% {
      transform: translate(-5px, 0);
    }
    50% {
      transform: translate(10px, -10px);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  .float {
    display: inline-block;
    animation: float 6s ease-in-out infinite;
  }

  @keyframes float {
    0% {
      transform: translate(0, 10px);
    }
    50% {
      transform: translate(10px, 0);
    }
    100% {
      transform: translate(0, 10px);
    }
  }
</style>
`
    // Insert the loading component at the beginning of the document's body.
    document.body.insertBefore(loaderHtmlComponent, document.body.firstChild)

    function removeHTMLComponent() {
      if (loaderHtmlComponent) {
        // Remove the loading component.
        loaderHtmlComponent.remove()
      }
    }

    // Register the 'page:finish' hook to perform actions after page loading is complete.
    nuxtApp.hook('page:finish', () => {
      setTimeout(() => {
        // Remove the loading component.
        const loader = document.getElementById('splash-container')
        if (loader) {
          loader.classList.add('container--hidden')
          loader.classList.remove('fade-in')
          setTimeout(() => {
            removeHTMLComponent()
          }, 200)
        } else {
          removeHTMLComponent()
        }
      }, Number(`2000`))
    })

    // Remove element after fatal error occures
    nuxtApp.hook('app:error', () => {
      // Remove the loading component.
      removeHTMLComponent()
    })
  }
})
